import { createAsyncStateHook } from './utils'
import { getCryptopanic } from 'src/services/cryptopanicServices'

export const useCryptopanic = createAsyncStateHook(
  'cryptopanic',
  getCryptopanic
)
